import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProspectFeature } from './prospect-feature';

@Component({
  selector: 'app-prospect-legend',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './prospect-legend.component.html',
  styleUrls: ['../../components/map-control.css', './prospect-legend.component.css'],
})
export class ProspectLegendComponent {
  constructor(public readonly feature: ProspectFeature) {}
}
